import { currencies, periods } from "_constants";
import { arrayOf, bool, number, oneOf, shape, string } from "prop-types";

import priceShape from "./price";
import spaceShape from "./space";

const proposal = {
  id: number,
  comment: string,
  creator: shape({
    id: number.isRequired,
    fname: string,
    lname: string,
  }).isRequired,
  deal: shape({
    id: number.isRequired,
  }).isRequired,
  type: string.isRequired,
  offering: bool,
  private: bool,
  executed: bool,
  dueDate: string,
  brokerFee: shape({
    value: number,
    currency: oneOf(currencies),
  }),
  legalFee: shape({
    value: number,
    currency: oneOf(currencies),
  }),
  movingAllowance: shape({
    value: number,
    currency: oneOf(currencies),
  }),
  tiAllowance: shape({
    value: number,
    currency: oneOf(currencies),
  }),
  otherCostsTitle: string,
  otherCosts: shape({
    value: number,
    currency: oneOf(currencies),
  }),
  ner: shape({
    value: number,
    currency: oneOf(currencies),
  }),
  term: shape({
    value: number,
    period: string,
  }),
  commencementDate: string,
  breakDates: arrayOf(string),
  expirationDate: string,
  deposit: shape({
    value: number,
    period: oneOf(Object.keys(periods)),
  }),
  renewalPeriod: shape({
    value: number,
    period: oneOf(Object.keys(periods)),
  }),
  billingPeriod: shape({
    value: number,
    period: oneOf(Object.keys(periods)),
  }),
  billingMethod: oneOf(["pre", "post"]),
  listPrice: shape(priceShape),
  spaces: arrayOf(shape(spaceShape)),
};

export default proposal;
